const config = {
  restApiKey: '0239e3b799683b851fa867e85be71696',
  redirectUri: 'https://dnd-9th-4-newple-app.vercel.app/auth',
  //redirectUri: 'http://localhost:3000/auth',
  backendUrl: 'https://dnd-newple-server.store',
};

export default config;
